/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".canvas-owner[_ngcontent-%COMP%], .webgl-canvas[_ngcontent-%COMP%]{width:100%;height:100%;margin:0;padding:0;overflow:hidden;pointer-events:auto}#overlay[_ngcontent-%COMP%]{width:100%;height:100%;margin:0;padding:0;left:0;top:0;position:absolute;overflow:hidden;z-index:10;pointer-events:none;opacity:.5;background-color:#fff}#spinner[_ngcontent-%COMP%]{width:100px;height:100px;left:50%;margin-left:50px;bottom:50%;margin-top:50px;z-index:10;position:absolute}"];
export { styles as styles };
